export default "__VITE_ASSET__BsZ3ZN7F__"